import React from 'react';
import ToggleButtonSelection from '../toggle-button-selection';
import moment from 'moment';

const daysOfWeekNames = moment.weekdaysShort();

const daysOfWeek = daysOfWeekNames.map((item, index) => {
  return {value: `${index}`, name: item};
});

export default function DaysOfWeek(props) {
  return <ToggleButtonSelection {...props} buttonOptions={daysOfWeek} />;
}
